<template>
  <div
    v-if="options.video.show.page.comments"
    class="box mb-3 single-video-comment-tabs"
  >
    <ul
      class="nav nav-tabs"
      role="tablist"
    >
      <li class="nav-item">
        <a
          id="retro-comments-tab"
          class="nav-link active"
          data-toggle="tab"
          href="#retro-comments"
          role="tab"
          aria-controls="retro"
          aria-selected="false"
        >
          Comments
        </a>
      </li>
      <!-- <li class="nav-item"> -->
      <!-- <a class="nav-link" id="disqus-comments-tab" data-toggle="tab" href="#disqus-comments" role="tab" aria-controls="disqus" aria-selected="true">Disqus Comments</a> -->
      <!-- </li> -->
      <!-- <li class="nav-item"> -->
      <!-- <a class="nav-link" id="facebook-comments-tab" data-toggle="tab" href="#facebook-comments" role="tab" aria-controls="facebook" aria-selected="false">Facebook Comments</a> -->
      <!-- </li> -->
    </ul>
    <div class="tab-content">
      <!-- <div class="tab-pane fade" id="disqus-comments" role="tabpanel" aria-labelledby="disqus-comments-tab"> -->
      <!-- <h1>Soon...</h1> -->
      <!-- </div> -->
      <!-- <div class="tab-pane fade" id="facebook-comments" role="tabpanel" aria-labelledby="facebook-comments-tab"> -->
      <!-- <h1>Soon...</h1> -->
      <!-- </div> -->
      <div
        id="retro-comments"
        class="tab-pane fade show active"
        role="tabpanel"
        aria-labelledby="retro-comments-tab"
      >
        <div class="reviews-members pt-0">
          <div class="media">
            <a href="#">
              <img
                class="mr-3"
                src="@/assets/theme/img/s1.png"
                alt="Generic placeholder image"
              >
            </a>
            <div class="media-body">
              <div class="form-members-body">
                <textarea
                  rows="1"
                  placeholder="Add a public comment..."
                  class="form-control"
                />
              </div>
              <div class="form-members-footer text-right mt-2">
                <b class="float-left">
                  {{ video.comment_count }} Comments
                </b>
                <button
                  class="btn btn-outline-danger btn-sm"
                  type="button"
                >
                  CANCEL
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  type="button"
                >
                  COMMENT
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="reviews-members">
          <div class="media">
            <a href="#">
              <img
                class="mr-3"
                src="@/assets/theme/img/s2.png"
                alt="Generic placeholder image"
              >
            </a>
            <div class="media-body">
              <div class="reviews-members-header">
                <h6 class="mb-1">
                  <a
                    class="text-black"
                    href="#"
                  >
                    Gurdeep MadGUI
                  </a>
                  <small class="text-gray">
                    2 months ago
                  </small>
                </h6>
              </div>
              <div class="reviews-members-body">
                <p>
                  reacthe last order. Even though they had Chefs in their open
                  kitchen they weren’t flexible to dish out few more items. Anyway the
                  food was super specially their stone dessert.
                </p>
              </div>
              <div class="reviews-members-footer">
                <a
                  class="total-like"
                  href="#"
                >
                  <i class="fas fa-thumbs-up" /> 123
                </a>
                <a
                  class="total-like"
                  href="#"
                >
                  <i class="fas fa-thumbs-down" /> 02
                </a>
                <span
                  dir="rtl"
                  class="total-like-user-main ml-2"
                >
                  <a
                    href="#"
                    title="Gurdeep MadGUI"
                    data-placement="top"
                    data-toggle="tooltip"
                  >
                    <img
                      class="total-like-user"
                      src="@/assets/theme/img/s1.png"
                      alt="Generic placeholder image"
                    >
                  </a>
                  <a
                    href="#"
                    title="Gurdeep MadGUI"
                    data-placement="top"
                    data-toggle="tooltip"
                  >
                    <img
                      class="total-like-user"
                      src="@/assets/theme/img/s2.png"
                      alt="Generic placeholder image"
                    >
                  </a>
                  <a
                    href="#"
                    title="Gurdeep MadGUI"
                    data-placement="top"
                    data-toggle="tooltip"
                  >
                    <img
                      class="total-like-user"
                      src="@/assets/theme/img/s3.png"
                      alt="Generic placeholder image"
                    >
                  </a>
                  <a
                    href="#"
                    title="Gurdeep MadGUI"
                    data-placement="top"
                    data-toggle="tooltip"
                  >
                    <img
                      class="total-like-user"
                      src="@/assets/theme/img/s4.png"
                      alt="Generic placeholder image"
                    >
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="reviews-members">
          <div class="media">
            <a href="#">
              <img
                alt="Generic placeholder image"
                src="@/assets/theme/img/s3.png"
                class="mr-3"
              >
            </a>
            <div class="media-body">
              <div class="reviews-members-header">
                <h6 class="mb-1">
                  <a
                    href="#"
                    class="text-black"
                  >
                    Gurdeep MadGUI
                  </a>
                  <small class="text-gray">
                    2 months ago
                  </small>
                </h6>
              </div>
              <div class="reviews-members-body">
                <p>
                  Was here impromptu in their first week, reacthe last order. Even
                  though they had Chefs in their open kitchen they weren’t flexible to
                  dish out few more items.
                </p>
              </div>
              <div class="reviews-members-footer">
                <a
                  href="#"
                  class="total-like"
                >
                  <i class="fas fa-thumbs-up" /> 123
                </a>
                <a
                  href="#"
                  class="total-like"
                >
                  <i class="fas fa-thumbs-down" /> 02
                </a>
                <span
                  class="total-like-user-main ml-2"
                  dir="rtl"
                >
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Gurdeep MadGUI"
                    href="#"
                  >
                    <img
                      alt="Generic placeholder image"
                      src="@/assets/theme/img/s5.png"
                      class="total-like-user"
                    >
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Gurdeep MadGUI"
                    href="#"
                  >
                    <img
                      alt="Generic placeholder image"
                      src="@/assets/theme/img/s6.png"
                      class="total-like-user"
                    >
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Gurdeep MadGUI"
                    href="#"
                  >
                    <img
                      alt="Generic placeholder image"
                      src="@/assets/theme/img/s7.png"
                      class="total-like-user"
                    >
                  </a>
                  <a
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Gurdeep MadGUI"
                    href="#"
                  >
                    <img
                      alt="Generic placeholder image"
                      src="@/assets/theme/img/s8.png"
                      class="total-like-user"
                    >
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    video: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
